export default {
    install (Vue) {
        var setWechatTitle = function(title, img) {
            if (title === undefined || window.document.title === title) {
                return
            }
            document.title = title
        }
        Vue.directive('wechat-title', function(el, binding) {
            setWechatTitle(binding.value, el.getAttribute('img-set') || null)
        })
    }
}